import type { ComponentProps } from "react";

const DropDownIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="12" height="17" viewBox="0 0 12 17" fill="none" {...props}>
      <path
        d="M5.19107 1.1236C5.5902 0.570537 6.4137 0.570536 6.81284 1.1236L10.0541 5.61479C10.5314 6.27616 10.0588 7.2 9.2432 7.2H2.76071C1.9451 7.2 1.47253 6.27616 1.94982 5.61479L5.19107 1.1236Z"
        fill="#696680"
      />
      <path
        d="M6.81284 15.0766C6.4137 15.6297 5.5902 15.6297 5.19107 15.0766L1.94983 10.5854C1.47253 9.92404 1.9451 9.0002 2.76071 9.0002H9.2432C10.0588 9.0002 10.5314 9.92404 10.0541 10.5854L6.81284 15.0766Z"
        fill="#696680"
      />
    </svg>
  );
};

export default DropDownIcon;
